var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "paySys-body", attrs: { id: "paySystem" } },
    [
      _c("div", { staticClass: "paysys-box" }, [
        _c("div", { staticClass: "paysys-all" }, [
          _c("div", {
            staticClass: "sys_back_icon",
            on: {
              click: function($event) {
                return _vm.backHistory()
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "paysys-title" }, [
            _vm._v(_vm._s(_vm.$t("language.paySystem.payTitle")))
          ]),
          _vm._v(" "),
          (!_vm.morePrivileges && _vm.user.vip) || !_vm.user.vip
            ? _c("div", { staticClass: "paySwitch" }, [
                !_vm.user.vip
                  ? _c("div", { staticClass: "switch-all" }, [
                      _c(
                        "div",
                        {
                          staticClass: "switch-left",
                          class: _vm.clickIndex == 0 ? "switch-click" : "",
                          on: {
                            click: function($event) {
                              return _vm.changeChoosePlan(0)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("language.paySystem.limitedData"))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "seitch-right",
                          class: _vm.clickIndex == 1 ? "switch-click" : "",
                          on: {
                            click: function($event) {
                              return _vm.changeChoosePlan(1)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("language.paySystem.unlimitedData"))
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.user.vip && _vm.isActiveLoginType()
                  ? _c("div", { staticClass: "switch-all" }, [
                      _c(
                        "div",
                        {
                          staticClass: "switch-left",
                          class: _vm.clickIndex == 0 ? "switch-click" : "",
                          on: {
                            click: function($event) {
                              return _vm.changeChoosePlan(0)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("language.paySystem.limitedData"))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "seitch-right",
                          class: _vm.clickIndex == 1 ? "switch-click" : "",
                          on: {
                            click: function($event) {
                              return _vm.changeChoosePlan(1)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("language.paySystem.unlimitedData"))
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.user.vip && !_vm.isActiveLoginType()
                  ? _c("div", { staticClass: "switch-all" }, [
                      _vm.user.payLevel > 1
                        ? _c(
                            "div",
                            {
                              staticClass: "switch-left",
                              class: _vm.clickIndex == 1 ? "switch-click" : "",
                              on: {
                                click: function($event) {
                                  return _vm.changeChoosePlan(1)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.paySystem.toUnlimited")
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user.payLevel > 1
                        ? _c(
                            "div",
                            {
                              staticClass: "seitch-right",
                              class: _vm.clickIndex == 2 ? "switch-click" : "",
                              on: {
                                click: function($event) {
                                  return _vm.changeChoosePlan(2)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.paySystem.moreTraffic")
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "allBottom",
              staticClass: "paySys-bottom",
              class:
                _vm.user.vip && _vm.user.payLevel <= 1
                  ? "paySys-bottom-unlimit"
                  : ""
            },
            [
              _c(
                "div",
                { staticClass: "paysys-div-all" },
                [
                  !_vm.user.vip && _vm.clickIndex != 2
                    ? _c("paySchemeTab", { ref: "payScheme" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user.vip && _vm.nowScheme && _vm.clickIndex != 2
                    ? _c("paySchemeTab", {
                        ref: "payScheme",
                        attrs: { payScheme: _vm.nowScheme, index: -1 }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.allowSchemes, function(allowScheme, index) {
                    return _c("paySchemeTab", {
                      key: index,
                      ref: "payScheme",
                      refInFor: true,
                      attrs: {
                        payScheme: allowScheme,
                        index: index,
                        isLimit: _vm.clickIndex == 0,
                        isVIP: _vm.user.vip,
                        isTraffic: _vm.clickIndex == 2,
                        indexMax: _vm.allowSchemes.length
                      }
                    })
                  })
                ],
                2
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "task-buttom pay_task_buttom" }),
      _vm._v(" "),
      _c("bindEmailDialog", { ref: "bindEmailDialog" }),
      _vm._v(" "),
      _c("payDiffDialog", { ref: "payDiffDialog" }),
      _vm._v(" "),
      _c("payErrorNoticeDialog", { ref: "payErrorNoticeDialog" }),
      _vm._v(" "),
      _c("bindEmailJumpDialog", { ref: "bindEmailJumpDialog" }),
      _vm._v(" "),
      _c("nowPaySchemeDialog", { ref: "nowPaySchemeDialog" }),
      _vm._v(" "),
      _c("iosPayTipDialog", { ref: "iosPayTipDialog" }),
      _vm._v(" "),
      _c("appNowPaySchemeDialog", { ref: "appNowPaySchemeDialog" }),
      _vm._v(" "),
      _c("userStarPopup", { ref: "userStarPopup" }),
      _vm._v(" "),
      _c("userStarJumpPopup", { ref: "userStarJumpPopup" }),
      _vm._v(" "),
      _c("userStarFeedbackPopup", { ref: "userStarFeedbackPopup" }),
      _vm._v(" "),
      _c("licenseShowDialog", {
        ref: "licenseShowDialog",
        attrs: { subscrId: _vm.user.subscrId }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fa87f70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa87f70","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/pay_system.vue
// module id = null
// module chunks = 